(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec789"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec789"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kWfK0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f3e56f3eac89eefa$export$71511d61b312f219; });

var $6tY97 = parcelRequire("6tY97");
function $f3e56f3eac89eefa$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $6tY97._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("6tY97", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4b841b45c75a3225$export$71511d61b312f219; });
function $4b841b45c75a3225$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hApvp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ccd99553ef7f1c61$export$71511d61b312f219; });
function $ccd99553ef7f1c61$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ccd99553ef7f1c61$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $ccd99553ef7f1c61$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("jlUaU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e16b8da7da809cdc$export$71511d61b312f219; });

var $dTQYG = parcelRequire("dTQYG");

var $d95Qy = parcelRequire("d95Qy");

var $eanwW = parcelRequire("eanwW");

var $J66Jb = parcelRequire("J66Jb");
function $e16b8da7da809cdc$export$71511d61b312f219(arr) {
    return (0, $dTQYG._)(arr) || (0, $d95Qy._)(arr) || (0, $J66Jb._)(arr) || (0, $eanwW._)();
}

});
parcelRegister("dTQYG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a1e981ac9d7864a0$export$71511d61b312f219; });

var $2PuG4 = parcelRequire("2PuG4");
function $a1e981ac9d7864a0$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $2PuG4._)(arr);
}

});
parcelRegister("2PuG4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $20f8241f6119e7d1$export$71511d61b312f219; });
function $20f8241f6119e7d1$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("d95Qy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9920a6ac5bee97c9$export$71511d61b312f219; });
function $9920a6ac5bee97c9$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("eanwW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a504407b7f865a13$export$71511d61b312f219; });
function $a504407b7f865a13$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("J66Jb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0878f0e8b254b036$export$71511d61b312f219; });

var $2PuG4 = parcelRequire("2PuG4");
function $0878f0e8b254b036$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $2PuG4._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $2PuG4._)(o, minLen);
}

});



var $kWfK0 = parcelRequire("kWfK0");

var $hApvp = parcelRequire("hApvp");

var $jlUaU = parcelRequire("jlUaU");
function $e1cd052829d5675e$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $caf1aa597f4cbd1e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $e1cd052829d5675e$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $caf1aa597f4cbd1e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $e1cd052829d5675e$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $caf1aa597f4cbd1e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $e1cd052829d5675e$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $c894140a215edaaf$export$8960430cfd85939f = Math.max;
var $c894140a215edaaf$export$96ec731ed4dcb222 = Math.min;
var $c894140a215edaaf$export$2077e0241d6afd3c = Math.round;



function $f37d9e7527880ed9$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $d9c690b841cdecdf$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $f37d9e7527880ed9$export$2e2bcd8739ae039)());
}


function $c335eeffae76f5ef$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $caf1aa597f4cbd1e$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $c894140a215edaaf$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $c894140a215edaaf$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $caf1aa597f4cbd1e$export$45a5e7f76e0caa8d)(element) ? (0, $e1cd052829d5675e$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $d9c690b841cdecdf$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $bac0746f55878fb7$export$2e2bcd8739ae039(node) {
    var win = (0, $e1cd052829d5675e$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $f12a1a2b10baa282$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $f965e022a80774b3$export$2e2bcd8739ae039(node) {
    if (node === (0, $e1cd052829d5675e$export$2e2bcd8739ae039)(node) || !(0, $caf1aa597f4cbd1e$export$1b3bfaa9684536aa)(node)) return (0, $bac0746f55878fb7$export$2e2bcd8739ae039)(node);
    else return (0, $f12a1a2b10baa282$export$2e2bcd8739ae039)(node);
}


function $6bb1165a8046b8fb$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $371b346bb4df23d8$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $caf1aa597f4cbd1e$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $1f81754e5ccffdc0$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $c335eeffae76f5ef$export$2e2bcd8739ae039)((0, $371b346bb4df23d8$export$2e2bcd8739ae039)(element)).left + (0, $bac0746f55878fb7$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $7ccb4509d8b9255f$export$2e2bcd8739ae039(element) {
    return (0, $e1cd052829d5675e$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $aa7475183f645caa$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $7ccb4509d8b9255f$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $1931fb91afc09919$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $c894140a215edaaf$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $c894140a215edaaf$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $1931fb91afc09919$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $caf1aa597f4cbd1e$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $caf1aa597f4cbd1e$export$1b3bfaa9684536aa)(offsetParent) && $1931fb91afc09919$var$isElementScaled(offsetParent);
    var documentElement = (0, $371b346bb4df23d8$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $c335eeffae76f5ef$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $6bb1165a8046b8fb$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $aa7475183f645caa$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $f965e022a80774b3$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $caf1aa597f4cbd1e$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $c335eeffae76f5ef$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $1f81754e5ccffdc0$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $c9545feda32e8dcf$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $c335eeffae76f5ef$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $6f2f85d02334b6e0$export$2e2bcd8739ae039(element) {
    if ((0, $6bb1165a8046b8fb$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $caf1aa597f4cbd1e$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $371b346bb4df23d8$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $e5ae406321c572fc$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $6bb1165a8046b8fb$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $caf1aa597f4cbd1e$export$1b3bfaa9684536aa)(node) && (0, $aa7475183f645caa$export$2e2bcd8739ae039)(node)) return node;
    return $e5ae406321c572fc$export$2e2bcd8739ae039((0, $6f2f85d02334b6e0$export$2e2bcd8739ae039)(node));
}





function $e5cc62e867a3625d$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $e5ae406321c572fc$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $e1cd052829d5675e$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $aa7475183f645caa$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($e5cc62e867a3625d$export$2e2bcd8739ae039((0, $6f2f85d02334b6e0$export$2e2bcd8739ae039)(target)));
}







function $bf9dc82c5f225e3d$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $6bb1165a8046b8fb$export$2e2bcd8739ae039)(element)) >= 0;
}




function $2bea3f48a329f15f$var$getTrueOffsetParent(element) {
    if (!(0, $caf1aa597f4cbd1e$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $7ccb4509d8b9255f$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $2bea3f48a329f15f$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $f37d9e7527880ed9$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $f37d9e7527880ed9$export$2e2bcd8739ae039)());
    if (isIE && (0, $caf1aa597f4cbd1e$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $7ccb4509d8b9255f$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $6f2f85d02334b6e0$export$2e2bcd8739ae039)(element);
    if ((0, $caf1aa597f4cbd1e$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $caf1aa597f4cbd1e$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $6bb1165a8046b8fb$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $7ccb4509d8b9255f$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $2bea3f48a329f15f$export$2e2bcd8739ae039(element) {
    var window = (0, $e1cd052829d5675e$export$2e2bcd8739ae039)(element);
    var offsetParent = $2bea3f48a329f15f$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $bf9dc82c5f225e3d$export$2e2bcd8739ae039)(offsetParent) && (0, $7ccb4509d8b9255f$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $2bea3f48a329f15f$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $6bb1165a8046b8fb$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $6bb1165a8046b8fb$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $7ccb4509d8b9255f$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $2bea3f48a329f15f$var$getContainingBlock(element) || window;
}


var $df2d599d544f2b4e$export$1e95b668f3b82d = 'top';
var $df2d599d544f2b4e$export$40e543e69a8b3fbb = 'bottom';
var $df2d599d544f2b4e$export$79ffe56a765070d2 = 'right';
var $df2d599d544f2b4e$export$eabcd2c8791e7bf4 = 'left';
var $df2d599d544f2b4e$export$dfb5619354ba860 = 'auto';
var $df2d599d544f2b4e$export$aec2ce47c367b8c3 = [
    $df2d599d544f2b4e$export$1e95b668f3b82d,
    $df2d599d544f2b4e$export$40e543e69a8b3fbb,
    $df2d599d544f2b4e$export$79ffe56a765070d2,
    $df2d599d544f2b4e$export$eabcd2c8791e7bf4
];
var $df2d599d544f2b4e$export$b3571188c770cc5a = 'start';
var $df2d599d544f2b4e$export$bd5df0f255a350f8 = 'end';
var $df2d599d544f2b4e$export$390fd549c5303b4d = 'clippingParents';
var $df2d599d544f2b4e$export$d7b7311ec04a3e8f = 'viewport';
var $df2d599d544f2b4e$export$ae5ab1c730825774 = 'popper';
var $df2d599d544f2b4e$export$ca50aac9f3ba507f = 'reference';
var $df2d599d544f2b4e$export$368f9a87e87fa4e1 = /*#__PURE__*/ $df2d599d544f2b4e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $df2d599d544f2b4e$export$b3571188c770cc5a,
        placement + "-" + $df2d599d544f2b4e$export$bd5df0f255a350f8
    ]);
}, []);
var $df2d599d544f2b4e$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($df2d599d544f2b4e$export$aec2ce47c367b8c3, [
    $df2d599d544f2b4e$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $df2d599d544f2b4e$export$b3571188c770cc5a,
        placement + "-" + $df2d599d544f2b4e$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $df2d599d544f2b4e$export$421679a7c3d56e = 'beforeRead';
var $df2d599d544f2b4e$export$aafa59e2e03f2942 = 'read';
var $df2d599d544f2b4e$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $df2d599d544f2b4e$export$c65e99957a05207c = 'beforeMain';
var $df2d599d544f2b4e$export$f22da7240b7add18 = 'main';
var $df2d599d544f2b4e$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $df2d599d544f2b4e$export$8d4d2d70e7d46032 = 'beforeWrite';
var $df2d599d544f2b4e$export$68d8715fc104d294 = 'write';
var $df2d599d544f2b4e$export$70a6e5159acce2e6 = 'afterWrite';
var $df2d599d544f2b4e$export$d087d3878fdf71d5 = [
    $df2d599d544f2b4e$export$421679a7c3d56e,
    $df2d599d544f2b4e$export$aafa59e2e03f2942,
    $df2d599d544f2b4e$export$6964f6c886723980,
    $df2d599d544f2b4e$export$c65e99957a05207c,
    $df2d599d544f2b4e$export$f22da7240b7add18,
    $df2d599d544f2b4e$export$bab79516f2d662fe,
    $df2d599d544f2b4e$export$8d4d2d70e7d46032,
    $df2d599d544f2b4e$export$68d8715fc104d294,
    $df2d599d544f2b4e$export$70a6e5159acce2e6
];


function $dc6508ccbbc6d45c$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $dc6508ccbbc6d45c$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $dc6508ccbbc6d45c$var$order(modifiers); // order based on phase
    return (0, $df2d599d544f2b4e$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $e9bdec3c7b8579fa$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $4ebc63b09271aa0b$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $4be1a396a3cdf337$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $4be1a396a3cdf337$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $4be1a396a3cdf337$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $4be1a396a3cdf337$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $4be1a396a3cdf337$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $caf1aa597f4cbd1e$export$45a5e7f76e0caa8d)(reference) ? (0, $e5cc62e867a3625d$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $e5cc62e867a3625d$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $e5cc62e867a3625d$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $dc6508ccbbc6d45c$export$2e2bcd8739ae039)((0, $4ebc63b09271aa0b$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$4be1a396a3cdf337$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $1931fb91afc09919$export$2e2bcd8739ae039)(_$reference, (0, $2bea3f48a329f15f$export$2e2bcd8739ae039)(_$popper), state.options.strategy === 'fixed'),
                    popper: (0, $c9545feda32e8dcf$export$2e2bcd8739ae039)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $e9bdec3c7b8579fa$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$4be1a396a3cdf337$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $4be1a396a3cdf337$export$8f7491d57c8f97a9 = /*#__PURE__*/ $4be1a396a3cdf337$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $bc922bcdcd7dd5c5$var$passive = {
    passive: true
};
function $bc922bcdcd7dd5c5$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $e1cd052829d5675e$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $bc922bcdcd7dd5c5$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $bc922bcdcd7dd5c5$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $bc922bcdcd7dd5c5$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $bc922bcdcd7dd5c5$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $bc922bcdcd7dd5c5$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $bc922bcdcd7dd5c5$var$effect,
    data: {}
};



function $7dd8a095c132a3aa$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $6be35a4dbf67639a$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $2f8070e9ef16a1a2$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $c21cac4533332415$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $7dd8a095c132a3aa$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $6be35a4dbf67639a$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $df2d599d544f2b4e$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $df2d599d544f2b4e$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $df2d599d544f2b4e$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $df2d599d544f2b4e$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $2f8070e9ef16a1a2$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $df2d599d544f2b4e$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $df2d599d544f2b4e$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $4ceadd2138fc2290$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $c21cac4533332415$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $4ceadd2138fc2290$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $4ceadd2138fc2290$var$popperOffsets,
    data: {}
};










var $ef6dfc408d1b9add$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $ef6dfc408d1b9add$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $c894140a215edaaf$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $c894140a215edaaf$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $ef6dfc408d1b9add$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $df2d599d544f2b4e$export$eabcd2c8791e7bf4);
    var sideY = (0, $df2d599d544f2b4e$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $2bea3f48a329f15f$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $e1cd052829d5675e$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $371b346bb4df23d8$export$2e2bcd8739ae039)(popper);
            if ((0, $7ccb4509d8b9255f$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $df2d599d544f2b4e$export$1e95b668f3b82d) || (placement === (0, $df2d599d544f2b4e$export$eabcd2c8791e7bf4) || placement === (0, $df2d599d544f2b4e$export$79ffe56a765070d2)) && variation === (0, $df2d599d544f2b4e$export$bd5df0f255a350f8)) {
            sideY = (0, $df2d599d544f2b4e$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $df2d599d544f2b4e$export$eabcd2c8791e7bf4) || (placement === (0, $df2d599d544f2b4e$export$1e95b668f3b82d) || placement === (0, $df2d599d544f2b4e$export$40e543e69a8b3fbb)) && variation === (0, $df2d599d544f2b4e$export$bd5df0f255a350f8)) {
            sideX = (0, $df2d599d544f2b4e$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $ef6dfc408d1b9add$var$unsetSides);
    var _ref4 = roundOffsets === true ? $ef6dfc408d1b9add$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $e1cd052829d5675e$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $ef6dfc408d1b9add$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $7dd8a095c132a3aa$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $6be35a4dbf67639a$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $ef6dfc408d1b9add$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $ef6dfc408d1b9add$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ef6dfc408d1b9add$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $ef6dfc408d1b9add$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $3adb49538a7f96c3$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $caf1aa597f4cbd1e$export$1b3bfaa9684536aa)(element) || !(0, $6bb1165a8046b8fb$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $3adb49538a7f96c3$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $caf1aa597f4cbd1e$export$1b3bfaa9684536aa)(element) || !(0, $6bb1165a8046b8fb$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $3adb49538a7f96c3$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $3adb49538a7f96c3$var$applyStyles,
    effect: $3adb49538a7f96c3$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $a8552b6c2abf8f0e$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $7dd8a095c132a3aa$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $df2d599d544f2b4e$export$eabcd2c8791e7bf4),
        (0, $df2d599d544f2b4e$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $df2d599d544f2b4e$export$eabcd2c8791e7bf4),
        (0, $df2d599d544f2b4e$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a8552b6c2abf8f0e$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $df2d599d544f2b4e$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $a8552b6c2abf8f0e$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a8552b6c2abf8f0e$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $a8552b6c2abf8f0e$var$offset
};


var $09e31cf6ba53762e$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $09e31cf6ba53762e$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $09e31cf6ba53762e$var$hash[matched];
    });
}



var $14cfc91e3b244459$var$hash = {
    start: 'end',
    end: 'start'
};
function $14cfc91e3b244459$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $14cfc91e3b244459$var$hash[matched];
    });
}







function $1977489e0303e7cf$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $e1cd052829d5675e$export$2e2bcd8739ae039)(element);
    var html = (0, $371b346bb4df23d8$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $d9c690b841cdecdf$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $1f81754e5ccffdc0$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $c3118ff4c8d50c2d$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $371b346bb4df23d8$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $bac0746f55878fb7$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $c894140a215edaaf$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $c894140a215edaaf$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $1f81754e5ccffdc0$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $7ccb4509d8b9255f$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $c894140a215edaaf$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $8f0bf4fdcb9d3e1a$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $caf1aa597f4cbd1e$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $2db35ecfacb7b7c8$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $120d4d4c67553912$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $c335eeffae76f5ef$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $120d4d4c67553912$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $df2d599d544f2b4e$export$d7b7311ec04a3e8f) ? (0, $2db35ecfacb7b7c8$export$2e2bcd8739ae039)((0, $1977489e0303e7cf$export$2e2bcd8739ae039)(element, strategy)) : (0, $caf1aa597f4cbd1e$export$45a5e7f76e0caa8d)(clippingParent) ? $120d4d4c67553912$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $2db35ecfacb7b7c8$export$2e2bcd8739ae039)((0, $c3118ff4c8d50c2d$export$2e2bcd8739ae039)((0, $371b346bb4df23d8$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $120d4d4c67553912$var$getClippingParents(element) {
    var clippingParents = (0, $e5cc62e867a3625d$export$2e2bcd8739ae039)((0, $6f2f85d02334b6e0$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $7ccb4509d8b9255f$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $caf1aa597f4cbd1e$export$1b3bfaa9684536aa)(element) ? (0, $2bea3f48a329f15f$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $caf1aa597f4cbd1e$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $caf1aa597f4cbd1e$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f0bf4fdcb9d3e1a$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $6bb1165a8046b8fb$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $120d4d4c67553912$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $120d4d4c67553912$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $120d4d4c67553912$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $c894140a215edaaf$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $c894140a215edaaf$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $c894140a215edaaf$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $c894140a215edaaf$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $120d4d4c67553912$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $cfcc017a0d4df2e2$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $a7682dc1dd8610ab$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $cfcc017a0d4df2e2$export$2e2bcd8739ae039)(), paddingObject);
}


function $530e700437279b74$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $4210f6d13e4cff31$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $df2d599d544f2b4e$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $df2d599d544f2b4e$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $df2d599d544f2b4e$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $a7682dc1dd8610ab$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $530e700437279b74$export$2e2bcd8739ae039)(padding, (0, $df2d599d544f2b4e$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $df2d599d544f2b4e$export$ae5ab1c730825774) ? (0, $df2d599d544f2b4e$export$ca50aac9f3ba507f) : (0, $df2d599d544f2b4e$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $120d4d4c67553912$export$2e2bcd8739ae039)((0, $caf1aa597f4cbd1e$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $371b346bb4df23d8$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $c335eeffae76f5ef$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $c21cac4533332415$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $2db35ecfacb7b7c8$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $df2d599d544f2b4e$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $df2d599d544f2b4e$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $df2d599d544f2b4e$export$79ffe56a765070d2),
                (0, $df2d599d544f2b4e$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $df2d599d544f2b4e$export$1e95b668f3b82d),
                (0, $df2d599d544f2b4e$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $2b3e301cd66c3daf$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $df2d599d544f2b4e$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $6be35a4dbf67639a$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $df2d599d544f2b4e$export$368f9a87e87fa4e1) : (0, $df2d599d544f2b4e$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $6be35a4dbf67639a$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $df2d599d544f2b4e$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $4210f6d13e4cff31$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $7dd8a095c132a3aa$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $8c4b987f604123e3$var$getExpandedFallbackPlacements(placement) {
    if ((0, $7dd8a095c132a3aa$export$2e2bcd8739ae039)(placement) === (0, $df2d599d544f2b4e$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $09e31cf6ba53762e$export$2e2bcd8739ae039)(placement);
    return [
        (0, $14cfc91e3b244459$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $14cfc91e3b244459$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $8c4b987f604123e3$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $7dd8a095c132a3aa$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $09e31cf6ba53762e$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $8c4b987f604123e3$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $7dd8a095c132a3aa$export$2e2bcd8739ae039)(placement) === (0, $df2d599d544f2b4e$export$dfb5619354ba860) ? (0, $2b3e301cd66c3daf$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $7dd8a095c132a3aa$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $6be35a4dbf67639a$export$2e2bcd8739ae039)(placement) === (0, $df2d599d544f2b4e$export$b3571188c770cc5a);
        var isVertical = [
            (0, $df2d599d544f2b4e$export$1e95b668f3b82d),
            (0, $df2d599d544f2b4e$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $4210f6d13e4cff31$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $df2d599d544f2b4e$export$79ffe56a765070d2) : (0, $df2d599d544f2b4e$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $df2d599d544f2b4e$export$40e543e69a8b3fbb) : (0, $df2d599d544f2b4e$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $09e31cf6ba53762e$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $09e31cf6ba53762e$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $8c4b987f604123e3$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $8c4b987f604123e3$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $cbef90d00085926a$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $37c12a931b13d32f$export$f28d906d67a997f3(min, value, max) {
    return (0, $c894140a215edaaf$export$8960430cfd85939f)(min, (0, $c894140a215edaaf$export$96ec731ed4dcb222)(value, max));
}
function $37c12a931b13d32f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $37c12a931b13d32f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $6b1a5839ef1f74c9$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $4210f6d13e4cff31$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $7dd8a095c132a3aa$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $6be35a4dbf67639a$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $2f8070e9ef16a1a2$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $cbef90d00085926a$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $df2d599d544f2b4e$export$1e95b668f3b82d) : (0, $df2d599d544f2b4e$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $df2d599d544f2b4e$export$40e543e69a8b3fbb) : (0, $df2d599d544f2b4e$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $df2d599d544f2b4e$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $df2d599d544f2b4e$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $c9545feda32e8dcf$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $cfcc017a0d4df2e2$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $37c12a931b13d32f$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $2bea3f48a329f15f$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $37c12a931b13d32f$export$f28d906d67a997f3)(tether ? (0, $c894140a215edaaf$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $c894140a215edaaf$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $df2d599d544f2b4e$export$1e95b668f3b82d) : (0, $df2d599d544f2b4e$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $df2d599d544f2b4e$export$40e543e69a8b3fbb) : (0, $df2d599d544f2b4e$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $df2d599d544f2b4e$export$1e95b668f3b82d),
            (0, $df2d599d544f2b4e$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $37c12a931b13d32f$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $37c12a931b13d32f$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $6b1a5839ef1f74c9$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $6b1a5839ef1f74c9$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $c78247f1ff03bc7b$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $a7682dc1dd8610ab$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $530e700437279b74$export$2e2bcd8739ae039)(padding, (0, $df2d599d544f2b4e$export$aec2ce47c367b8c3)));
};
function $c78247f1ff03bc7b$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $7dd8a095c132a3aa$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $2f8070e9ef16a1a2$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $df2d599d544f2b4e$export$eabcd2c8791e7bf4),
        (0, $df2d599d544f2b4e$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $c78247f1ff03bc7b$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $c9545feda32e8dcf$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $df2d599d544f2b4e$export$1e95b668f3b82d) : (0, $df2d599d544f2b4e$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $df2d599d544f2b4e$export$40e543e69a8b3fbb) : (0, $df2d599d544f2b4e$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $2bea3f48a329f15f$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $37c12a931b13d32f$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $c78247f1ff03bc7b$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f0bf4fdcb9d3e1a$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $c78247f1ff03bc7b$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $c78247f1ff03bc7b$var$arrow,
    effect: $c78247f1ff03bc7b$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $7e059eb0663dc34a$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7e059eb0663dc34a$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $df2d599d544f2b4e$export$1e95b668f3b82d),
        (0, $df2d599d544f2b4e$export$79ffe56a765070d2),
        (0, $df2d599d544f2b4e$export$40e543e69a8b3fbb),
        (0, $df2d599d544f2b4e$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7e059eb0663dc34a$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $4210f6d13e4cff31$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $4210f6d13e4cff31$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7e059eb0663dc34a$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7e059eb0663dc34a$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7e059eb0663dc34a$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7e059eb0663dc34a$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7e059eb0663dc34a$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $7e059eb0663dc34a$var$hide
};




var $6a00b780324bf691$export$d34966752335dd47 = [
    (0, $bc922bcdcd7dd5c5$export$2e2bcd8739ae039),
    (0, $4ceadd2138fc2290$export$2e2bcd8739ae039),
    (0, $ef6dfc408d1b9add$export$2e2bcd8739ae039),
    (0, $3adb49538a7f96c3$export$2e2bcd8739ae039),
    (0, $a8552b6c2abf8f0e$export$2e2bcd8739ae039),
    (0, $8c4b987f604123e3$export$2e2bcd8739ae039),
    (0, $6b1a5839ef1f74c9$export$2e2bcd8739ae039),
    (0, $c78247f1ff03bc7b$export$2e2bcd8739ae039),
    (0, $7e059eb0663dc34a$export$2e2bcd8739ae039)
];
var $6a00b780324bf691$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $4be1a396a3cdf337$export$ed5e13716264f202)({
    defaultModifiers: $6a00b780324bf691$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $d1e574a854d33eba$var$showAttribute = 'data-show';
var $d1e574a854d33eba$export$4edfb2fe829b4a56 = function(anchor, tooltip) {
    if (!anchor || !tooltip) {
        if (!anchor) console.warn('No anchor provided');
        if (!tooltip) console.warn('No tooltip provided');
        return;
    }
    // Create a Popper instance
    var popperInstance = (0, $6a00b780324bf691$export$8f7491d57c8f97a9)(anchor, tooltip, {
        placement: tooltip.getAttribute('data-tooltip-placement') || 'top'
    });
    var show = function() {
        // Make the tooltip visible
        tooltip.setAttribute($d1e574a854d33eba$var$showAttribute, '');
        // Enable the event listeners
        popperInstance.setOptions(function(options) {
            return (0, $hApvp._)((0, $kWfK0._)({}, options), {
                modifiers: (0, $jlUaU._)(options.modifiers).concat([
                    {
                        name: 'eventListeners',
                        enabled: true
                    }
                ])
            });
        });
        // Update its position
        popperInstance.update();
    };
    var hide = function() {
        // Hide the tooltip
        tooltip.removeAttribute($d1e574a854d33eba$var$showAttribute);
        // Disable the event listeners
        popperInstance.setOptions(function(options) {
            return (0, $hApvp._)((0, $kWfK0._)({}, options), {
                modifiers: (0, $jlUaU._)(options.modifiers).concat([
                    {
                        name: 'eventListeners',
                        enabled: false
                    }
                ])
            });
        });
    };
    [
        'mouseenter',
        'focus'
    ].forEach(function(type) {
        anchor.addEventListener(type, show);
    });
    [
        'mouseleave',
        'blur'
    ].forEach(function(type) {
        anchor.addEventListener(type, hide);
    });
    return {
        show: show,
        hide: hide
    };
};


var $e2e00498bd3afe65$export$c16a9a598ac2ae39 = function(text) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'info';
    var tooltip = document.createElement('div');
    tooltip.className = "tooltip tooltip--".concat(type);
    tooltip.setAttribute('role', 'tooltip');
    if (type === 'info') tooltip.setAttribute('data-color-scheme', 'highlight');
    tooltip.innerHTML = "<div data-popper-arrow></div>".concat(text);
    document.body.appendChild(tooltip);
    return tooltip;
};


var $e4d33e34ebaaf55d$var$selectors = {
    tooltipAnchor: '[data-tooltip-text]'
};
// HTML API
document.querySelectorAll($e4d33e34ebaaf55d$var$selectors.tooltipAnchor).forEach(function(anchor) {
    var tooltipText = anchor.getAttribute('data-tooltip-text');
    var tooltipType = anchor.getAttribute('data-tooltip-type') || 'info';
    if (!tooltipText) return;
    var tooltip = (0, $e2e00498bd3afe65$export$c16a9a598ac2ae39)(tooltipText, tooltipType);
    (0, $d1e574a854d33eba$export$4edfb2fe829b4a56)(anchor, tooltip);
});
// Global API
window.createTooltip = (0, $e2e00498bd3afe65$export$c16a9a598ac2ae39);
window.bindTooltip = (0, $d1e574a854d33eba$export$4edfb2fe829b4a56);

})();
//# sourceMappingURL=tooltip.min.js.map
